<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-table
          :items="itemsComputed"
          :fields="fields"
          striped
          bordered
          responsive
        >
          <template
            slot="action"
            slot-scope="data"
          >
            <b-button
              class="mx-2"
              variant="warning"
              @click="editFormHandler(data.item.id)"
            >
              แก้ไข
            </b-button>
            <b-button
              variant="danger"
              class="mx-2"
              @click="deleteDataConfirm(data.item.id)"
            >
              ลบ
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

  export default {
    name: "DirectionTable",
    props: {
      items: {
        type: Array,
        default: () => []
      },
      updateDataHandler: {
        type: Function,
        default: () => false
      },
      deleteDataHandler: {
        type: Function,
        default: () => false
      },
      contentHandler: {
        type: Function,
        default: () => false
      },
      getDataHandler: {
        type: Function,
        default: () => false
      }
    },
    data() {
      return {
        fields: [
          {
            name: 'CODE',
            key: 'id'
          },
          {
            name: 'เส้นทาง',
            key: 'direction'
          },
          {
            name: 'Action',
            key: 'action'
          }
        ],
      }
    },
    computed: {
      itemsComputed: {
        get() {
          return this.items
        },
        set(value) {
          this.$emit('update:items', value)
        }
      }
    },
    methods: {
      async editFormHandler(id) {
        await this.getDataHandler(id)
        this.contentHandler('form')
      },
      async deleteDataConfirm(id) {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          await this.deleteDataHandler(id, password)
        } else {
          return
        }
      }
    }
  }
</script>

<style scoped>

</style>